import React from 'react'
import { Link, useParams } from 'react-router-dom';
import More from '../../../../Components/Icons/More';
import axiosInstance from '../../../../Services/axiosCommon';
import { Modal, notification } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { GetAccess } from '../../../../Components/Utils/roles';

const ViewMoreC =({ data, getData, id }) => {
    const { officeId } = useParams();
    const { confirm } = Modal;

    const consultantEdit =
                                           GetAccess("consultants_edit")
                                         
                                         const consultantDelete =
                                           GetAccess("consultants_delete")
    const [api, contextHolder] = notification.useNotification();
    const handleDelete = async (id, removevalue) => {
      confirm({
        title: `Do you Want to delete ${removevalue}?`,
        centered: true,
        icon: <ExclamationCircleFilled />,
        content: `The ${removevalue} will be removed from the List`,
        okText: "Yes",
        cancelText: "No",
        // okButtonProps: {
        //   style: {
        //     backgroundColor: "#048178",
        //     borderColor: "#048178",
        //     color: "#FFFFFF",
        //   },
        // },
        onOk() {
          axiosInstance
            .delete(`/suppliers/${id}`)
            .then((res) => {
              if (res.status === 201 || res.status === 200) {
                getData();
                api.success({
                  message: `Deleted successfully`,
                  description: res?.data?.msg || " ",
                  placement: "bottomRight",
                });
              } else {
                api.error({
                  message: `Delete failed`,
                  description: res?.data?.msg || "Network error",
                  placement: "bottomRight",
                });
              }
            })
            .catch((error) => {
              api.error({
                message: `Delete failed`,
                description:
                  error?.response?.data?.msg || "Sever error (or) Network error",
                placement: "bottomRight",
              });
            });
        },
        onCancel() {},
      });
    };
  
    return (
      <>
        {contextHolder}
        <div className="text-[#344767]  relative dropdown inline-block z-50">
          <div className=" cursor-pointer underline-offset-8 text-xs mx-auto font-semibold flex items-center">
            <span
              className=" w-7 h-7 bg-gray-50 flex flex-col items-center justify-center rounded-full"
              style={{ border: "1px solid #C0C0C0" }}
            >
              <More />
            </span>
          </div>
          <ul className="dropdown-menuOne   text-[#344767] text-left  rounded-lg absolute -left-[80px] -top-4 overflow-hidden hidden  z-50 shadow-lg">
            
            {true && (
              <li className=" w-[100px] bg-black block m-0">
                <span
                  className="bg-white hover:bg-gray-100 py-2 px-2 block whitespace-no-wrap text-xs font-medium"
                  // onClick={() => setOpen(true)}
                >
                  <Link
                    className=" text-black hover:text-black"
                    to={`/contacts/consultants/view/${data?.supplierId}`}
                    state={{ data: data }}
                  >
                    View
                  </Link>
                </span>
              </li>
            )}
  
            {consultantEdit && (
              <li className=" w-[100px] bg-black block m-0">
                <span
                  className="bg-white hover:bg-gray-100 py-2 px-2 block whitespace-no-wrap text-xs font-medium"
                  // onClick={() => setOpen(true)}
                >
                  <Link
                    className=" text-black hover:text-black"
                    to={`/contacts/consultants/edit/${data?.supplierId}`}
                    state={{ data: data }}
                  >
                    Edit
                  </Link>
                </span>
              </li>
            )}
            {consultantDelete && (
              <li className="">
                <a
                  className="bg-white hover:bg-gray-100 text-black hover:text-black py-2 px-2 block whitespace-no-wrap text-xs font-medium"
                  // to='/members'
                  href="#"
                  onClick={() => {
                    handleDelete(id, data?.refNumber);
                  }}
                >
                  Delete
                </a>
              </li>
            )}
          </ul>
        </div>
      </>
    );
  };

export default ViewMoreC;